<div
  class="generic-table-shell tw-flex tw-flex-col tw-h-full tw-bg-white tw-rounded-lg tw-overflow-hidden tw-w-full"
  [style.--generic-table-row-height.px]="rowHeightPx()"
  [style.--generic-table-header-height.px]="headerHeightPx"
>
  @let firstColFixed = isFirstColumnFixed();
  @let fixedColLeft = fixedColumnLeftOffset();
  <div
    class="tw-flex tw-flex-col tw-flex-1 tw-min-h-0"
    [ngClass]="firstColFixed ? 'tw-overflow-auto' : 'tw-overflow-x-auto tw-overflow-y-hidden'"
  >
  <div class="tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-w-max tw-min-w-full">
  <div
    class="tw-grid tw-w-max tw-min-w-full tw-box-border tw-items-stretch tw-h-[var(--generic-table-header-height,50px)] tw-min-h-[var(--generic-table-header-height,50px)] tw-bg-gray-50 tw-border-b tw-border-gray-200"
    [style.grid-template-columns]="gridTemplateColumns()"
    [ngClass]="{
      'tw-sticky': stickyHeader(),
      'tw-top-0': stickyHeader(),
      'tw-z-10': stickyHeader()
    }"
  >
    <ng-template #truncatedHeaderLabel let-label="label">
      <app-truncation-tooltip
        [text]="label"
        [hostNgClass]="headerLabelClasses"
      ></app-truncation-tooltip>
    </ng-template>

    @if (selectable()) {
      @let headerState = headerCheckboxState();
      <div
        class="tw-box-border tw-flex tw-items-center tw-justify-center tw-px-3 tw-py-3 tw-h-[var(--generic-table-header-height,50px)] tw-min-h-[var(--generic-table-header-height,50px)]"
        [ngClass]="firstColFixed ? ['tw-sticky', 'tw-z-[11]', 'tw-bg-gray-50'] : []"
        [style.left]="firstColFixed ? '0' : null"
      >
        <button
          type="button"
          class="tw-bg-none tw-p-0 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-rounded tw-border tw-cursor-pointer"
          [ngClass]="{
            'tw-bg-blue-600': headerState === 'allSelected',
            'tw-border-blue-600': headerState === 'allSelected' || headerState === 'someSelected',
            'tw-border-gray-300': headerState === 'none',
            'tw-bg-gray-50': headerState !== 'allSelected' && !firstColFixed,
            'tw-bg-transparent': headerState !== 'allSelected' && firstColFixed
          }"
          [attr.aria-checked]="headerState === 'someSelected' ? 'mixed' : headerState === 'allSelected'"
          (click)="toggleSelectAll()"
        >
          @if (headerState === 'allSelected') {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="tw-w-4 tw-h-4" aria-hidden="true">
              <path d="M5 13l4 4L19 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          } @else if (headerState === 'someSelected') {
            <span class="tw-block tw-w-2.5 tw-h-0.5 tw-bg-blue-600 tw-rounded-sm" aria-hidden="true"></span>
          }
        </button>
      </div>
    }

    @let currentSort = sort();
    @for (column of columns; track column.field(); let colIndex = $index) {
      @let isActiveSortColumn = currentSort.field === column.field();
      @let columnAlignClass = columnJustifyClass(column.align());
      @let isFixedHeaderCol = firstColFixed && colIndex === 0;
      <div
        class="tw-box-border tw-flex tw-items-center tw-gap-1 tw-px-3 xl:tw-px-4 tw-py-3 tw-min-w-0 tw-w-full tw-h-[var(--generic-table-header-height,50px)] tw-min-h-[var(--generic-table-header-height,50px)]"
        [ngClass]="isFixedHeaderCol
          ? [columnAlignClass, 'tw-sticky', 'tw-z-[11]', 'tw-bg-gray-50', 'generic-table-fixed-col-edge']
          : [columnAlignClass]"
        [style.left]="isFixedHeaderCol ? fixedColLeft : null"
      >
        @if (column.sortable()) {
          <button
            type="button"
            class="tw-bg-none tw-border-none tw-p-0 tw-flex tw-items-center tw-gap-1 tw-min-w-0 tw-w-full tw-cursor-pointer"
            [ngClass]="[columnAlignClass, columnTextAlignClass(column.align())]"
            (click)="onColumnHeaderClick(column.field())"
          >
            <ng-container
              [ngTemplateOutlet]="truncatedHeaderLabel"
              [ngTemplateOutletContext]="{ label: column.header() }"
            ></ng-container>
            <span class="tw-flex-shrink-0">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                  d="M3.84846 5.40694H8.15154C8.39199 5.40736 8.62819 5.35097 8.83555 5.24362C9.04291 5.13627 9.21387 4.9819 9.33065 4.79654C9.44742 4.61119 9.50575 4.40163 9.49955 4.18966C9.49336 3.9777 9.42288 3.77106 9.29544 3.59126L7.14222 0.556814C7.02118 0.386394 6.85301 0.245891 6.65351 0.148494C6.45401 0.0510968 6.22972 0 6.00168 0C5.77365 0 5.54935 0.0510968 5.34985 0.148494C5.15035 0.245891 4.98219 0.386394 4.86115 0.556814L2.70658 3.59126C2.57923 3.77093 2.50876 3.9774 2.50248 4.18922C2.49621 4.40103 2.55435 4.61046 2.67089 4.79576C2.78742 4.98106 2.95809 5.13547 3.16517 5.24294C3.37225 5.35042 3.60818 5.40704 3.84846 5.40694Z"
                  [attr.fill]="isActiveSortColumn && currentSort.direction === sortDirection.DESC ? '#D1D5DB' : '#6B7280'"
                />
                <path
                  d="M8.15154 6.59366H3.84846C3.60801 6.59323 3.37181 6.64962 3.16445 6.75697C2.95709 6.86432 2.78613 7.0187 2.66935 7.20405C2.55258 7.3894 2.49425 7.59896 2.50045 7.81093C2.50664 8.0229 2.57712 8.22953 2.70456 8.40934L4.85778 11.4432C4.97882 11.6136 5.14699 11.7541 5.34649 11.8515C5.54599 11.9489 5.77028 12 5.99832 12C6.22635 12 6.45065 11.9489 6.65015 11.8515C6.84965 11.7541 7.01781 11.6136 7.13885 11.4432L9.29207 8.40874C9.41919 8.22916 9.48951 8.02286 9.49576 7.81124C9.502 7.59962 9.44394 7.39037 9.32758 7.20521C9.21123 7.02004 9.04082 6.86568 8.83404 6.75815C8.62725 6.65062 8.3916 6.59383 8.15154 6.59366Z"
                  [attr.fill]="isActiveSortColumn && currentSort.direction === sortDirection.ASC ? '#D1D5DB' : '#6B7280'"
                />
              </svg>
            </span>
          </button>
        } @else {
          <div class="tw-flex tw-items-center tw-min-w-0 tw-w-full" [ngClass]="columnAlignClass">
            <ng-container
              [ngTemplateOutlet]="truncatedHeaderLabel"
              [ngTemplateOutletContext]="{ label: column.header() }"
            ></ng-container>
          </div>
        }
      </div>
    }
  </div>

  <div class="tw-relative tw-flex tw-flex-col tw-flex-1 tw-min-h-0">
  <ng-template #skeletonRow let-index="index">
    @let rowFirstColFixed = isFirstColumnFixed();
    @let rowFixedColLeft = fixedColumnLeftOffset();
    <div
      class="tw-grid tw-w-max tw-min-w-full tw-box-border tw-items-stretch tw-h-[var(--generic-table-row-height,auto)] tw-min-h-[var(--generic-table-row-height,auto)] tw-border-b tw-border-gray-200 last:tw-border-b-0"
      [style.grid-template-columns]="gridTemplateColumns()"
      [ngClass]="index % 2 === 0 ? 'tw-bg-white' : 'tw-bg-gray-50'"
    >
      @if (selectable()) {
        <div [ngClass]="selectCellClasses(index, rowFirstColFixed)" [style.left]="rowFirstColFixed ? '0' : null">
          <ngx-skeleton-loader count="1" [theme]="skeletonBlockTheme({ width: '20px', height: '20px', borderRadius: '4px' })" animation="pulse"></ngx-skeleton-loader>
        </div>
      }

      @for (skeleton of columnSkeletonConfigs(); track skeleton.field; let colIndex = $index) {
        <div
          [ngClass]="bodyCellClasses(columns[colIndex], colIndex, index, rowFirstColFixed)"
          [style.left]="rowFirstColFixed && colIndex === 0 ? rowFixedColLeft : null"
        >
          <div [ngClass]="skeletonInnerCellClasses(skeleton)">
            @for (block of skeleton.blocks; track $index) {
              @if (skeleton.layout === 'row') {
                <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-center">
                  <ngx-skeleton-loader count="1" [theme]="skeletonBlockTheme(block)" animation="pulse"></ngx-skeleton-loader>
                </div>
              } @else {
                <ngx-skeleton-loader count="1" [theme]="skeletonBlockTheme(block)" animation="pulse"></ngx-skeleton-loader>
              }
            }
          </div>
        </div>
      }
    </div>
  </ng-template>

  @if (isLoading()) {
    <div
      class="tw-flex-1 tw-min-h-0"
      [ngClass]="firstColFixed ? 'tw-overflow-visible' : 'tw-overflow-y-auto'"
      role="status"
      aria-label="Loading table"
    >
      @for (rowIndex of loadingSkeletonRows(); track rowIndex) {
        <ng-container [ngTemplateOutlet]="skeletonRow" [ngTemplateOutletContext]="{ index: rowIndex }"></ng-container>
      }
    </div>
  } @else if (!items().length) {
    <ng-content select="[genericTableEmpty]"></ng-content>
  } @else {
    <ng-template #tableRow let-row let-index="index">
      @let rowFirstColFixed = isFirstColumnFixed();
      @let rowFixedColLeft = fixedColumnLeftOffset();
      @let rowHighlighted = isRowHighlighted(row);
      <div
        class="tw-grid tw-w-max tw-min-w-full tw-box-border tw-items-stretch tw-h-[var(--generic-table-row-height,auto)] tw-min-h-[var(--generic-table-row-height,auto)] tw-border-b tw-border-gray-200 last:tw-border-b-0"
        [style.grid-template-columns]="gridTemplateColumns()"
        [ngClass]="rowBackgroundClass(index, rowHighlighted)"
        [attr.aria-current]="rowHighlighted ? 'true' : null"
      >
        @if (selectable()) {
          @let itemKey = getRowKey(row);
          @let rowSelected = isKeySelected(itemKey);
          <div [ngClass]="selectCellClasses(index, rowFirstColFixed, rowHighlighted)" [style.left]="rowFirstColFixed ? '0' : null">
            <button
              type="button"
              class="tw-bg-none tw-p-0 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-rounded tw-border tw-cursor-pointer"
              [ngClass]="{
                'tw-bg-blue-600 tw-border-blue-600': rowSelected,
                'tw-border-gray-300 tw-bg-gray-50': !rowSelected && !rowFirstColFixed,
                'tw-border-gray-300 tw-bg-transparent': !rowSelected && rowFirstColFixed
              }"
              [attr.aria-checked]="rowSelected"
              (click)="toggleRowSelection(row)"
            >
              @if (rowSelected) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="tw-w-4 tw-h-4" aria-hidden="true">
                  <path d="M5 13l4 4L19 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              }
            </button>
          </div>
        }

        @for (column of columns; track column.field(); let colIndex = $index) {
          <div
            [ngClass]="bodyCellClasses(column, colIndex, index, rowFirstColFixed, rowHighlighted)"
            [style.left]="rowFirstColFixed && colIndex === 0 ? rowFixedColLeft : null"
          >
            @if (column.cellDef?.template) {
              <ng-container
                [ngTemplateOutlet]="column.cellDef!.template"
                [ngTemplateOutletContext]="{ $implicit: row }"
              ></ng-container>
            }
          </div>
        }
      </div>
    </ng-template>

    @if (useVirtualScroll()) {
      <cdk-virtual-scroll-viewport
        autosize
        class="generic-table-viewport tw-flex-1 tw-min-h-0 tw-w-full"
        [ngClass]="firstColFixed ? 'tw-overflow-x-visible' : 'tw-overflow-x-hidden'"
        [minBufferPx]="virtualScrollMinBufferPx()"
        [maxBufferPx]="virtualScrollMaxBufferPx()"
        (scroll)="onViewportScroll()"
      >
        <div *cdkVirtualFor="let row of items(); trackBy: trackByFn; let i = index">
          <ng-container [ngTemplateOutlet]="tableRow" [ngTemplateOutletContext]="{ $implicit: row, index: i }"></ng-container>
        </div>
        @if (isLoadingMore()) {
          <ng-container [ngTemplateOutlet]="skeletonRow" [ngTemplateOutletContext]="{ index: items().length }"></ng-container>
        }
      </cdk-virtual-scroll-viewport>
    } @else {
      <div
        class="tw-flex-1 tw-min-h-0"
        [ngClass]="firstColFixed ? 'tw-overflow-visible' : 'tw-overflow-y-auto'"
      >
        @for (row of items(); track trackByFn($index, row); let i = $index) {
          <ng-container [ngTemplateOutlet]="tableRow" [ngTemplateOutletContext]="{ $implicit: row, index: i }"></ng-container>
        }
        @if (isLoadingMore()) {
          <ng-container [ngTemplateOutlet]="skeletonRow" [ngTemplateOutletContext]="{ index: items().length }"></ng-container>
        }
      </div>
    }
  }
  </div>
  </div>
  </div>

  <ng-content></ng-content>
</div>
